/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DataProductAssetInputDto } from './DataProductAssetInputDto';
import type { FilterConditionGroupDto } from './FilterConditionGroupDto';

export type DataProductAssetDynamicInputDto = (DataProductAssetInputDto & {
    conditionGroups?: Array<FilterConditionGroupDto>;
    logicalOperator?: DataProductAssetDynamicInputDto.logicalOperator;
} & {
    conditionGroups: Array<FilterConditionGroupDto>;
    logicalOperator: DataProductAssetDynamicInputDto.logicalOperator;
});

export namespace DataProductAssetDynamicInputDto {

    export enum logicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
